import { render } from "./AdministrationMain.vue?vue&type=template&id=5e1f5edd&scoped=true"
import script from "./AdministrationMain.vue?vue&type=script&lang=js"
export * from "./AdministrationMain.vue?vue&type=script&lang=js"

import "./AdministrationMain.vue?vue&type=style&index=0&id=5e1f5edd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1f5edd"]])

export default __exports__